const POSITION_NAMES = [
  "gross_portfolio_exposure",
  "post_mitigation_portfolio_exposure",
  "capital_tail_position",
  "transferred_financial_exposure",
  "retained_financial_exposure",
  "above_limit_uninsured_exposure",
];

const normalizePosition = (position) => {
  const source = position && typeof position === "object" ? position : {};
  return {
    availability: source.availability ?? "UNAVAILABLE",
    metrics: source.metrics && typeof source.metrics === "object" ? { ...source.metrics } : {},
    analyticsContext: source.analytics_context && typeof source.analytics_context === "object"
      ? { ...source.analytics_context }
      : {},
    transformation: source.transformation && typeof source.transformation === "object"
      ? { ...source.transformation }
      : null,
  };
};

export const adaptDecisionAnalyticsV1 = (payload) => {
  if (payload?.schema_version !== 1) {
    throw new Error("Unsupported Decision Analytics schema version.");
  }
  const sourcePositions = payload.analytics?.positions ?? {};
  const positions = Object.fromEntries(
    POSITION_NAMES.map((name) => [name, normalizePosition(sourcePositions[name])])
  );
  const optimizerSource = payload.analytics?.optimizers ?? {};
  return {
    schemaVersion: 1,
    positions,
    scenarioContext: payload.analytics?.scenario_context ?? {
      availability: "UNAVAILABLE",
      analytics_context: null,
    },
    optimizers: {
      crossModelPrecedence: optimizerSource.cross_model_precedence ?? null,
      families: Array.isArray(optimizerSource.families)
        ? optimizerSource.families.map((family) => ({ ...family }))
        : [],
    },
    governance: payload.governance ?? null,
    historicalEvidence: payload.historical_evidence ?? null,
  };
};

export { POSITION_NAMES };
